import api from "./api";

export const postException = async (body) => {
  return api
    .post({
      body,
      endpoint: "/exception-time-booking",
      port: process.env.REACT_APP_PORT_OPENHOUR,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
